import type { ErrorDiagnostics as Diagnostics, ErrorPresentation } from "./errorPresentation";
import { diagnosticDetails } from "./errorPresentation";

/** Keep stable codes and original evidence available without making them the main user message. */
export function ErrorDiagnostics({ diagnostics }: { diagnostics: Diagnostics }) {
  const details = diagnosticDetails(diagnostics.details);
  return <details className="mt-2 text-xs text-muted" data-testid="error-diagnostics">
    <summary className="cursor-pointer">Technical details</summary>
    <div className="mt-1 space-y-1 break-words">
      {diagnostics.status !== undefined && <p>HTTP status: <code className="mono">{diagnostics.status}</code></p>}
      {diagnostics.code && <p>Error code: <code className="mono">{diagnostics.code}</code></p>}
      <p>{diagnostics.message}</p>
      {details && <pre className="mono whitespace-pre-wrap break-words">{details}</pre>}
    </div>
  </details>;
}

export function ErrorExplanation({ presentation }: { presentation: ErrorPresentation }) {
  return <div role={presentation.tone === "warn" ? "status" : undefined}>
    <p className="text-danger">{presentation.message}</p>
    <p>{presentation.dataStatus}</p>
    <p>{presentation.nextAction}</p>
    <ErrorDiagnostics diagnostics={presentation.diagnostics} />
  </div>;
}
